import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { PropsWithChildren, useEffect, useState } from 'react'

import { bvaAPI, facadeApi, userApiClient } from 'api'
import { ApiInstance } from 'api/common/createApi'
import { loginRequest } from 'auth/config'

interface HubApiProviderProps extends PropsWithChildren {
  getToken?: () => Promise<string>
}

const apiInstances: ApiInstance[] = [bvaAPI, facadeApi, userApiClient]

export const HubApiProvider = ({ children, getToken }: HubApiProviderProps) => {
  const { instance, accounts } = useMsal()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (accounts.length === 0) return
    const account = accounts[0]
    const getMsalToken = async () => {
      if (getToken) return getToken()
      try {
        const response = await instance.acquireTokenSilent({ ...loginRequest, account })
        return response.accessToken
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError && process.env.REACT_APP_REDIRECT_URI) {
          window.location.href = process.env.REACT_APP_REDIRECT_URI
        }
        return ''
      }
    }

    const interceptors = apiInstances.map(apiInstance =>
      apiInstance.client.interceptors.request.use(async config => {
        const accessToken = await getMsalToken()
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`
          config.headers.Client = 'playground-dev-fe'
        }
        return config
      }),
    )

    setIsReady(true)
    return () =>
      interceptors.forEach((interceptor, index) => apiInstances[index].client.interceptors.request.eject(interceptor))
  }, [accounts, getToken, instance])

  return isReady ? <>{children}</> : null
}
